import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import SectionChart from '../shared/sectionChart/SectionChart';
import SectionHero from '../shared/sectionHero/SectionHero';
import Switcher from '../shared/switcher/Switcher';
import AverageSalaryByEnglishLevel from './AverageSalaryByEnglishLevel';
import {
  AVERAGESALARYBYROLEANDEXPERIENCETABS,
  AVERAGESALARYTABS,
  HERODATA
} from './Benefits.constants';
import { StyledSection } from './Benefits.styled';
import LocationPreference from './LocationPreference';

const Benefits: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');
  const heroData = HERODATA(t);
  const averageSalaryTabs = AVERAGESALARYTABS(t);
  const averageSalaryByRoleAndExperienceTabs =
    AVERAGESALARYBYROLEANDEXPERIENCETABS(t);

  return (
    <StyledSection>
      <SectionHero
        background={getPublicPath(
          '/images/stateSector/2023/benefits-hero-bg.webp'
        )}
        backgroundSm={getPublicPath(
          '/images/stateSector/2023/benefits-hero-bg-sm.webp'
        )}
        title={t('mandecar23.benefits.hero.title')}
        desc={t('mandecar23.benefits.hero.desc')}
        data={heroData}
      />
      <SectionChart
        title={t('mandecar23.benefits.location.title')}
        desc={t('mandecar23.benefits.location.desc')}
      >
        <LocationPreference />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.benefits.average-salary-language.title')}
        desc={t('mandecar23.benefits.average-salary-language.desc')}
        descExtra={t('mandecar23.benefits.average-salary-language.descExtra')}
      >
        <Switcher
          tabsName={averageSalaryTabs.tabsName}
          tabs={averageSalaryTabs.tabs}
        />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.benefits.average-salary-role.title')}
        desc={t('mandecar23.benefits.average-salary-role.desc')}
        descExtra={t('mandecar23.benefits.average-salary-role.descExtra')}
      >
        <Switcher
          tabsName={averageSalaryByRoleAndExperienceTabs.tabsName}
          tabs={averageSalaryByRoleAndExperienceTabs.tabs}
          label={averageSalaryByRoleAndExperienceTabs.label}
        />
      </SectionChart>
      <SectionChart
        title={t('mandecar23.benefits.english.title')}
        desc={t('mandecar23.benefits.english.desc')}
        descExtra={t('mandecar23.benefits.english.descExtra')}
      >
        <AverageSalaryByEnglishLevel />
      </SectionChart>
    </StyledSection>
  );
};

export default Benefits;
